import { Grid, SectionedGridContainer, Skeleton } from '@razz-team/ui-web';

export function TransactionGroupSkeleton() {
  return (
    <SectionedGridContainer direction="column">
      <Grid>
        <Skeleton variant="text" width={120} height={40} />
      </Grid>
      <Grid justifyContent="space-between">
        <Grid gap={2} alignItems="center">
          <Skeleton variant="circular" width={40} height={40} />
          <Skeleton variant="rounded" width={120} height={32} />
        </Grid>
        <Grid gap={2} alignItems="center">
          <Skeleton variant="rounded" width={120} height={40} />
          <Skeleton variant="rounded" width={120} height={40} />
        </Grid>
      </Grid>
    </SectionedGridContainer>
  );
}
